import FlowNode from './flowNode.js';

class QuestionNode extends FlowNode {
  constructor(id, data) {
    super(id, data);
    this.question = data.question;
    this.answers = data.answers;
  }

  getQuestion() {
    return this.question;
  }

  getAnswers() {
    return this.answers;
  }
}

export default QuestionNode;
